exports.onClientEntry = () => {
  if (window.location.pathname.endsWith("/conteudo/17396/inep-volta-a-ficar-sem-presidente")) {
    window.embeddedChatbotConfig = {
      chatbotId: "A_S0Isxu1rHhWLT0RPmS3",
      domain: "www.chatbase.co",
    };

    const script$ = document.createElement("script");

    script$.src = "https://www.chatbase.co/embed.min.js";
    script$.setAttribute("chatbotId", "A_S0Isxu1rHhWLT0RPmS3");
    script$.setAttribute("domain", "www.chatbase.co");
    script$.defer = true;

    window.document.body.insertAdjacentElement("beforeend", script$);
  }

  window.setCookiesToCompleteRegistrationRedirect = (url) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + 60 * 60 * 1000);
  
    document.cookie = `ane_complemento_cadastro_redirect_url=${url};expires=${expires.toUTCString()};path=/;domain=.novaescola.org.br`;
  }

  /**
   * Adicionando botão flutuando nas tags via scrip do estaticos
   * @task - SA-240
   */
  const scripts = [
    "https://estaticos.novaescola.org.br/chat-wpp-popover.js",
    "https://estaticos.novaescola.org.br/localizacao-popup.js",
    "https://estaticos.novaescola.org.br/whatsapp-popover.js"
  ];

  scripts.forEach(src => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true;

    if (src.includes("whatsapp-popover")) {
      script.setAttribute("data-event", "conteudo jornalismo");
      script.setAttribute("data-project", "JORNALISMO");
      script.setAttribute("data-href", "https://api.whatsapp.com/send/?phone=5511999732391&text=Ol%C3%A1%2C+quero+planejar+aulas&type=phone_number&app_absent=0")
    }

    document.body.appendChild(script);
  });

  const audimaScript = document.createElement("script");
  audimaScript.src = "https://menu.audima.co/accessibility.js?position=bottomRight";
  audimaScript.onload = () => {
    const checkBtn = setInterval(() => {
      const audimaBtn = document.querySelector("#accessibility-menu");
      if (audimaBtn) {
        audimaBtn.style.bottom = "170px";
        clearInterval(checkBtn);
      }
    }, 50);
  };

  audimaScript.defer = true;
  document.body.appendChild(audimaScript);

  const script = document.createElement("script");
  script.src = "https://audio4.audima.co/audima-widget.js";
  script.defer = true;
  document.body.appendChild(script);
};